import React, { useEffect, useState } from 'react';
import { Card, Table, Spinner, Alert } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { getNewReleases } from '../../services/exploreApi';
import Pagination from '../common/Pagination';
import {
  ListDesktop,
  ListMobile,
  MobileCard,
  MobileCardTop,
  MobileCardTitle,
  MobileCardRow,
} from '../common/ListMobileLayout';

const formatPublicAt = (timestamp) => {
  if (!timestamp) return '—';
  return new Date(timestamp * 1000).toLocaleString();
};

const ExploreNewReleases = () => {
  const [songs, setSongs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [pageSize] = useState(20);

  const fetch = async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await getNewReleases({ page, items_per_page: pageSize });
      setSongs(res.data?.data || []);
      const objs = res.data?.objects;
      setTotal(objs?.total ?? objs?.count ?? 0);
    } catch (err) {
      setError(err.response?.data?.message || err.message || 'Failed');
      setSongs([]);
      setTotal(0);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page]);

  const moodLabel = (mood) => (Array.isArray(mood) ? mood.join(', ') : mood || '—');

  return (
    <div className="dashboard-list-page">
      <h2 className="mb-4">
        <FontAwesomeIcon icon={faPlus} className="me-2" />
        New Releases
      </h2>
      {error && <Alert variant="danger" onClose={() => setError(null)} dismissible>{error}</Alert>}
      <Card>
        <Card.Body>
          {loading ? (
            <div className="text-center py-4"><Spinner animation="border" /></div>
          ) : songs.length === 0 ? (
            <p className="text-muted text-center py-4">No public songs yet</p>
          ) : (
            <>
              <ListDesktop>
                <Table hover className="mb-0">
                  <thead>
                    <tr>
                      <th>Task ID</th>
                      <th>Title</th>
                      <th>Creator</th>
                      <th>Genre</th>
                      <th>Mood</th>
                      <th>Public at</th>
                    </tr>
                  </thead>
                  <tbody>
                    {songs.map((s, idx) => (
                      <tr key={s.task_id || idx}>
                        <td><code>{s.task_id}</code></td>
                        <td>{s.title || '—'}</td>
                        <td>{s.creator_display_name || s.creator_user_id || '—'}</td>
                        <td>{s.genre || '—'}</td>
                        <td>{moodLabel(s.mood)}</td>
                        <td>{formatPublicAt(s.public_at)}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </ListDesktop>

              <ListMobile>
                {songs.map((s, idx) => (
                  <MobileCard key={s.task_id || idx}>
                    <MobileCardTop>
                      <MobileCardTitle>{s.title || '—'}</MobileCardTitle>
                    </MobileCardTop>
                    <MobileCardRow label="Task ID" mono>
                      {s.task_id || '—'}
                    </MobileCardRow>
                    <MobileCardRow label="Creator">
                      {s.creator_display_name || s.creator_user_id || '—'}
                    </MobileCardRow>
                    <MobileCardRow label="Genre">{s.genre || '—'}</MobileCardRow>
                    <MobileCardRow label="Mood">{moodLabel(s.mood)}</MobileCardRow>
                    <MobileCardRow label="Public at">{formatPublicAt(s.public_at)}</MobileCardRow>
                  </MobileCard>
                ))}
              </ListMobile>

              <Pagination currentPage={page} totalItems={total} itemsPerPage={pageSize} onPageChange={setPage} />
            </>
          )}
        </Card.Body>
      </Card>
    </div>
  );
};

export default ExploreNewReleases;
